import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\theight: ", ";\n\twidth: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\n\tbox-shadow: ", ";\n\theight: ", ";\n\tmin-height: ", ";\n\tmin-width: ", ";\n\twidth: ", ";\n\n\t&:checked {\n\t\t", ";\n\n\t\tbackground: transparent;\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
import * as checkboxStyles from '../Checkbox/Checkbox.styles';
export var RadioWrapperView = styled.div(_templateObject(), checkboxStyles.CheckboxWrapper);
export var Radio = css(_templateObject2(), checkboxStyles.Checkbox, ui.borderRadius.circle, ui.get('radioBoxShadow'), ui.get('radioSize'), ui.get('radioSize'), ui.get('radioSize'), ui.get('radioSize'), ui.border.control.focus);
export var RadioIconView = styled.div(_templateObject3(), checkboxStyles.CheckboxIcon);
export var RadioDotView = styled.div(_templateObject4(), ui.background.admin, ui.borderRadius.circle, ui.get('radioDotSize'), ui.get('radioDotSize'));